// src/pages/AdminDashboard.js
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const { currentUser, isSuperAdmin } = useAuth();
  const [users, setUsers] = useState([]);
  const [selectedUid, setSelectedUid] = useState("");
  const [newRole, setNewRole] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  // If the user is not a superadmin, redirect them
  useEffect(() => {
    if (!isSuperAdmin) {
      navigate("/");
    }
  }, [isSuperAdmin, navigate]);

  // Fetch users from your admin API endpoint
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        // Get the Firebase ID token (force refresh for demo purposes)
        const token = await currentUser.getIdToken(true);
        const response = await fetch("https://api-zgou5a2hta-uc.a.run.app/api/admin/users", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data.users);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    if (currentUser) {
      fetchUsers();
    }
  }, [currentUser]);

  // Handler to update user claims
  const handleUpdateClaims = async (e) => {
    e.preventDefault();
    if (!selectedUid || !newRole) {
      setMessage("Please enter both User ID and new Role");
      return;
    }

    try {
      const token = await currentUser.getIdToken(true);
      const response = await fetch(
        `https://api-zgou5a2hta-uc.a.run.app/api/admin/users/${selectedUid}/claims`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ role: newRole })
        }
      );
      const data = await response.json();
      if (response.ok) {
        setMessage(`Success: ${data.message}`);
      } else {
        setMessage(`Error: ${data.error}`);
      }
    } catch (error) {
      console.error("Error updating claims:", error);
      setMessage("Error updating claims");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Admin Dashboard</h1>
      <h2>Superadmin Access Only</h2>
      {message && <p>{message}</p>}
      
      <section style={{ marginBottom: "30px" }}>
        <h3>User List</h3>
        {users.length === 0 ? (
          <p>No users found.</p>
        ) : (
          <table border="1" cellPadding="8">
            <thead>
              <tr>
                <th>User ID</th>
                <th>Email</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.email}</td>
                  <td>{user.role || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      <section>
        <h3>Update User Role</h3>
        <form onSubmit={handleUpdateClaims}>
          <div>
            <label>User ID:</label>
            <input
              type="text"
              value={selectedUid}
              onChange={(e) => setSelectedUid(e.target.value)}
              placeholder="Enter User ID"
            />
          </div>
          <div>
            <label>New Role:</label>
            <input
              type="text"
              value={newRole}
              onChange={(e) => setNewRole(e.target.value)}
              placeholder="e.g., admin or superadmin"
            />
          </div>
          <button type="submit">Update Role</button>
        </form>
      </section>
    </div>
  );
};

export default AdminDashboard;
